import Dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/ru'

Dayjs.locale('ru')
Dayjs.extend(updateLocale)
Dayjs.updateLocale('ru', {
    relativeTime: {
        future: 'через %s',
        past: '%s назад',
        s: 'несколько секунд',
        m: 'минуту',
        mm: '%d минут',
        h: '1 час',
        hh: '%d часов',
        d: '1 день',
        dd: '%d дней',
        M: '1 месяц',
        MM: '%d месяцев',
        y: '1 год',
        yy: '%d лет',
    },
})

Dayjs.extend(duration)
Dayjs.extend(relativeTime)

// Dayjs with Russian locale
export const dayjs: typeof Dayjs = Dayjs
